// collaboratorServices.js

import apiClient from './apiClient';

export const getCollaborators = async () => {
    const response = await apiClient.get('/collaborators.php');
    return response.data;
};

export const addCollaborator = async (collaborator) => {
    const response = await apiClient.post('/users.php?action=create', {
        email: collaborator.email,
        password: collaborator.password,
        nome: collaborator.nome,
        cognome: collaborator.cognome,
        role: collaborator.role
    });
    return response.data;
};

export const updateCollaborator = async (collaborator) => {
    const response = await apiClient.post('/users.php?action=update', {
        id: collaborator.id,
        email: collaborator.email,
        password: collaborator.password,
        nome: collaborator.nome,
        cognome: collaborator.cognome,
        role: collaborator.role,
    });
    return response.data;
};

export const removeCollaborator = async (collaboratorId) => {
    const response = await apiClient.delete(`/users.php?action=delete&user_id=${collaboratorId}`);
    return response.data;
};

export const getUserDetails = async (userId) => {
    const response = await apiClient.get(`/user_details.php?action=get&user_id=${userId}`);
    return response.data;
};

export const updateUserDetails = async (formData) => {
    const response = await apiClient.post('/user_details.php?action=save', formData);
    return response.data;
};

export const saveAdminDetails = async (payload) => {
    const response = await apiClient.post('/user_details.php?action=save_admin', payload);
    return response.data;
};

export const deleteUserAttachment = async (attachmentId) => {
    const response = await apiClient.post('/user_details.php?action=delete_attachment', { attachment_id: attachmentId });
    return response.data;
};
